import { Checkboxes, resetCheckboxFacet } from "./checkboxes/Checkboxes";
import { FacetChangeEvent, ResourcedTexts, FacetType } from "../SearchFilterResultData";
import { RadioButtons, resetRadioButtonsFacet } from "./radio-buttons/RadioButtons";
import { resetSelectFacet, Select } from "./select/Select";
import { ReactElement } from "react";

export function resetFacet(facet: FacetType): FacetType {
  if (!facet.visible) {
    return facet;
  }

  switch (facet.type) {
    case "checkbox":
      return resetCheckboxFacet(facet);
    case "radio":
      return resetRadioButtonsFacet(facet);
    case "select":
      return resetSelectFacet(facet);
  }
}

type FacetProps = {
  facet: FacetType;
  onChange: FacetChangeEvent;
  resourcedTexts: ResourcedTexts;
  disabled: boolean;
};

export function Facet({ facet, onChange, disabled }: FacetProps) {
  function renderFacet(): ReactElement {
    switch (facet.type) {
      case "checkbox":
        return <Checkboxes facet={facet} onChange={onChange} disabled={disabled} />;
      case "radio":
        return <RadioButtons facet={facet} onChange={onChange} disabled={disabled} />;
      case "select":
        return <Select facet={facet} onChange={onChange} disabled={disabled} />;
    }
  }

  if (!facet.visible || (facet.type === "select" && facet.displayInSearchBar)) {
    return null;
  }

  return (
    <div className="facet">
      <span className="facet__title">{facet.name}</span>
      <div className="facet__content">{renderFacet()}</div>
    </div>
  );
}
